/**
 * Show different text on the CTAs on the pricing page.
 */

export const FLAG_PRICING_CARD_CTA = 'p_pricing--pricing-card-cta';

/**
 * A/B test, B variant: the old "Saving X% with yearly billing" price note.
 * Off (the control, and what SSR renders) is "Billed yearly, or monthly for £X".
 */

export const FLAG_PRICING_ANNUAL_SAVING_NOTE = 'p_pricing--annual-saving-note';

/**
 * A/B test: the compact plan picker for logged-in free users hitting a premium
 * Music download (DEV-7218). Only evaluated for that audience.
 */

export const FLAG_FREE_PREMIUM_DOWNLOAD_MODAL = 'free-premium-download-modal';
